import ComponentManager from '@/Management/ComponentManager';
import ToolBarLinkViewModel from '@/Components/Links/ToolBarLinkViewModel';
import GlobalConfiguration from '@/Management/GlobalConfiguration';
import Utilities from '@/Utility/Utilities';
import { IFilterViewModel } from '#/DefaultViewExtensionInterfaces';
import { IListViewDTO } from "coreframetypings/dto";
import FilterLinkViewModel from '@/Components/Links/FilterLink/FilterLinkViewModel';
import RADApplication from '@/Management/RADApplication';

export default class PublicFilterEditLinkViewModel extends ToolBarLinkViewModel {

    protected filterSource: IFilterViewModel;
    protected listView: KnockoutObservable<IListViewDTO>;
    protected filterLink: FilterLinkViewModel;

    public constructor(protected params: any) {
        super($.extend({
            tooltipErgName: 'PUBLIC_FILTER_EDIT_TOOLTIP',
            imageSource: GlobalConfiguration.inlineImages.PUBLIC_FILTER_EDIT,
            locator: 'filter-edit'
        }, params));

        this.filterSource = this.paramOrDefault(this.params.filterSource, null);
        this.filterLink = this.paramOrDefault(this.params.filterLink, null);
        this.setRequiredObservables();

        this.defineSubscription(this.isActive, (isActive) => {
            this.filterSource?.editPublicChips(isActive);
            this.filterLink?.isEnabled(!isActive);
            this.filterLink?.isActive(!isActive);
        });
    }

    /**
     * @override 
     */
    protected createIsVisibleObservable(): KnockoutObservable<boolean> {
        if (!Utilities.isNullOrUndefined(this.params.isVisible)) {
            return this.observableOrDefault(this.params.isVisible);
        }

        this.setRequiredObservables();

        return this.createWritableComputed(() => {
            return this.listView().showFilter && this.userCanEdit();
        });
    }

    /**
     * @override 
     */
    public onClick(openInNewWindow?: boolean, event?: JQuery.Event): void {
        if (!this.userCanEdit()) { return; }

        const filter = this.filterSource;
        if (this.isActive()) {
            if (!this.filterLink.isActive()) {
                filter?.resetFilter();

                if (!_.isEmpty(filter?.filterChipsViewModel?.activeChips())) {
                    filter?.filterChipsViewModel?.activeChips([]);
                }
            }
            this.isActive(false);

            filter?.isVisible(this.filterLink?.isActive());
        }
        else {
            this.isActive(true);

            this.listView().showFilter = true;
            filter?.isVisible(true);
        }

        filter?.rearrange();
    }

    public showPublicFilterEdit(): void {
        this.isActive(true);
    }

    private setRequiredObservables(): void {
        if (Utilities.isNullOrUndefined(this.listView)) {
            this.listView = this.observableOrDefault(this.params.listView);
        }
    }

    private userCanEdit() {
        return RADApplication.getInstance().user.isAllowedConfigurePublicUserData() === true;
    }
}

ComponentManager.setViewModel('PublicFilterEditLink', PublicFilterEditLinkViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');